<style lang="scss" scoped>
.sidebar-wrapper {
  position: relative;
  margin-left: 0.65rem;
  margin-top: 2.1rem;
}

.sidebar {
  position: absolute;
  width: max-content;
  overflow-y: auto;
  z-index: 20;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>

<script>
import menuItemIcon from "@c/menu-item-icon.vue";
import menuItem from "@c/menu-item.vue";
export default {
  components: { menuItem, menuItemIcon },
  data() {
    return {};
  },
  computed: {
    hasUnworkedPermission() {
      if (this.currentAccountHasPermissions(["ORGANIZATION_RISK_ADMIN"])) {
        return true;
      }

      return false;
    },
  },
};
</script>

<template>
  <div class="sidebar-wrapper">
    <div class="sidebar">
      <nav class="dashboard-content--nav">
        <menu-item-icon href="/organization" icon="iconoir-dashboard-speed" :name="$t('organization.panel')" />
        <menu-item-icon href="/organization/roadmap" icon="iconoir-maps-arrow" :name="$t('roadmap.platform.text')" />
        <menu-item-icon href="/organization/settings" icon="iconoir-settings" :name="$t('organization.settings')" />
        <menu-item-icon href="/organization/unit-hierarchy" icon="iconoir-network-reverse" :name="$t('organization-hierarchy.text')" />
        <menu-item-icon href="/organization/asset-groups" icon="iconoir-keyframes" :name="$t('asset-group.text')" />
        <!-- <menu-item-icon href="/organization/asset-group/inventory" icon="iconoir-network-right" :name="$t('asset-group.inventory.title')" />
        <menu-item-icon href="/organization/asset-group/criticality" icon="iconoir-activity" :name="$t('asset-group.degree-of-criticality')" /> -->

        <menu-item-icon href="/organization/members" icon="iconoir-user-circle" :name="$t('organization.members.text')" />
        <!-- <menu-item-icon href="/organization/asset-groups" icon="iconoir-keyframes" :name="$t('asset-group.text')" /> -->
        <menu-item-icon href="/organization/thirdparty" icon="iconoir-community" :name="$t('thirdparty.plural')" />
        <menu-item-icon href="/organization/policy" icon="iconoir-shield-check" :name="$t('policy.plural')" />
        <menu-item-icon href="/organization/tasks" icon="iconoir-archery" :name="$t('task.plural')" />
        <menu-item-icon href="/organization/question-set-survey" icon="iconoir-chat-bubble-question" :name="$t('question-set.plural')" />
        <!-- <menu-item-icon v-if="hasUnworkedPermission" href="/organization/risk-decision" icon="iconoir-task-list" :name="$t('risk.levels')" /> -->
        <!-- <menu-item-icon href="/organization/risk" icon="iconoir-shield-alert" :name="$t('risk.text')" /> -->
        <menu-item-icon href="/organization/application" icon="iconoir-bookmark-book" :name="$t('application.text')" />
        <menu-item-icon href="/organization/announcement" icon="bx bx bxs-megaphone" :name="$t('announcement.plural')" />
        <menu-item-icon href="/organization/file-manager" icon="iconoir-submit-document" :name="$t('file-manager.text')" />
        <hr />
        <menu-item-icon href="/" tag="a" icon="iconoir-view-grid" :name="$t('dashboard.text')" />

        <menu-item
          v-if="hasCurrentOrganizationAccessable('RISK')"
          href="/risk/dashboard"
          tag="a"
          image="/icons/risk.svg"
          imageActive="/icons/risk-active.svg"
          :name="$t('product.risk.product')"
        />
        <menu-item
          v-if="hasCurrentOrganizationAccessable('GDPR')"
          href="/gdpr/roadmap"
          tag="a"
          image="/icons/gdpr.svg"
          imageActive="/icons/gdpr-active.svg"
          :name="$t('product.gdpr.product')"
        />
        <menu-item
          v-if="hasCurrentOrganizationAccessable('KVKK')"
          href="/kvkk/roadmap"
          tag="a"
          image="/icons/kvkk.svg"
          imageActive="/icons/kvkk-active.svg"
          :name="$t('product.kvkk.product')"
        />
        <menu-item
          v-if="hasCurrentOrganizationAccessable('DDO')"
          href="/ddo/roadmap"
          tag="a"
          image="/icons/ddo.svg"
          imageActive="/icons/ddo-active.svg"
          :name="$t('product.ddo.product')"
        />
        <menu-item
          v-if="hasCurrentOrganizationAccessable('BGYS')"
          href="/bgys/roadmap"
          tag="a"
          image="/icons/bgys.svg"
          imageActive="/icons/bgys-active.svg"
          :name="$t('product.bgys.product')"
        />
      </nav>
    </div>
  </div>
</template>
